import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=be620d12&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"
import style0 from "./Audio.vue?vue&type=style&index=0&id=be620d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be620d12",
  null
  
)

export default component.exports